module.exports = "<div class=\"user-details-component user-guardians\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      GUARDIANS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"guardians-grid\">\r\n      <div id=\"guardians-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-guardians/user-guardians.html
 ** module id = 617
 ** module chunks = 0
 **/